// script to add the facebook div to the faithwords homepage
function addFacebookDiv() {
  const body = document.getElementById('add-facebook-chatbot');
  if (body) {
    fbDoScript();
  }
}

function fbDoScript() {
  const scriptTag = document.createElement('script');
  const script = `window.fbAsyncInit = function() {
    FB.init({
      appId            : '2282602335172252',
      autoLogAppEvents : true,
      xfbml            : true,
      version          : 'v5.0'
    });
  };
  (function(d, s, id) {
  var js, fjs = d.getElementsByTagName(s)[0];
  if (d.getElementById(id)) return;
  js = d.createElement(s); js.id = id;
  js.src = "https://connect.facebook.net/en_US/sdk/xfbml.customerchat.js";
  fjs.parentNode.insertBefore(js, fjs);
}(document, 'script', 'facebook-jssdk'));`;
  scriptTag.append(script);
  document.body.insertBefore(scriptTag, document.body.firstChild);
  const secondScript = document.createElement('script');
  secondScript.src = 'https://connect.facebook.net/en_US/sdk.js';
  secondScript.async = true;
  secondScript.defer = true;
  const firstElement = document.getElementById('zbwpbdy');
  document.body.insertBefore(secondScript, firstElement);
  const idDiv = document.createElement('div');
  idDiv.setAttribute('class', 'fb-customerchat');
  idDiv.setAttribute('page_id', '101529671356045');
  document.body.append(idDiv);
}

addFacebookDiv();
